import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './card.css'

const Card = (props) => {
  return (
    <div className={`card-container1 ${props.rootClassName} `}>
      <div className="card-container2">
        <img
          alt={props.imageAlt}
          src={props.imageSrc}
          loading="lazy"
          className="card-image"
        />
        <div className="card-container3">
          <h3 className="card-text1 H1_extrasmall">
            {props.heading1 ?? (
              <Fragment>
                <span className="card-text6">MX600 Pulse HP 5m</span>
              </Fragment>
            )}
          </h3>
          <span className="card-text2 text_medium">
            {props.text ?? (
              <Fragment>
                <span className="card-text3">
                  <span>Ток: 600А</span>
                  <br></br>
                </span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
    </div>
  )
}

Card.defaultProps = {
  imageSrc: '/1_Solution/1_2_2-Kolarc/MX/mx_600_pulse-300h.webp',
  imageAlt: '',
  text: undefined,
  rootClassName: '',
  heading1: undefined,
}

Card.propTypes = {
  imageSrc: PropTypes.string,
  imageAlt: PropTypes.string,
  text: PropTypes.element,
  rootClassName: PropTypes.string,
  heading1: PropTypes.element,
}

export default Card
